const updateBlockTypeRemote = ({
  pageState: { editorBlocks },
  data: { blockId, blockType, data, editor, updatedAt }
}) => {
  return {
    editorBlocks: {
      ...editorBlocks,
      [blockId]: {
        ...editorBlocks[blockId],
        data: JSON.parse(JSON.stringify(data)),
        type: blockType,
        editor,
        isEdited: true,
        updatedAt
      }
    },
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  };
};

export default updateBlockTypeRemote;
